import socketIOClient from "socket.io-client";
import config from "./config";
import {parseJwt,b64toBlob} from "../utils/services";
import { getDimensions,setJobQtyData,setStockUnitData} from "../redux/actions";
import { setWebNotificationUnreadCount } from "../redux/actions/NotificationsSettings";
import { showToast } from "./functions";

// function socketServices() {
//     if (localStorage.getItem("token")) {
//         var tokenData = parseJwt(localStorage.getItem("token"))
//         var userData = localStorage.getItem("user")
//         // console.log(tokenData,userData)
//         if (userData && tokenData && tokenData.iat) {
//             const { _id, name, email, base } = JSON.parse(userData) || {}
//             var socket = socketIOClient(config.socketURL,
//                 {
//                     transports: ['websocket', "polling"],
//                     query: `name=${name}&userId=${_id}&userName=${email}&iat=${tokenData.iat}&socketID=${localStorage.getItem("socketID")}&base=${base}&exp=${tokenData.exp}`
//                 });

//             socket.on("socket-added", socketData => {
//                 localStorage.setItem("socketID", socketData?.data)
//                 console.log("socket-added::", socketData?.data)
//             });
//             return socket
//         }

//         return null;
//     }

//     return null;
// }

function socketServices() {
    const token = localStorage.getItem("token");
    if (!token) {
        cleanupSocket()
        return null
    };

    const tokenData = parseJwt(token);
    const userDataStr = localStorage.getItem("user");

    if (!userDataStr || !tokenData) {
        cleanupSocket()
        return null
    };

    const user = JSON.parse(userDataStr);
    const { _id, name, email, base } = user;

    // If socket already exists and is connected, return it
    if (window.currentSocket && window.currentSocket.connected) {
        return window.currentSocket;
    }

    const socket = socketIOClient(config.socketURL, {
        transports: ['websocket', 'polling'],
        query: {
            name: name || "",
            userId: _id || "",
            userName: email || "",
            base: base || "",
            exp: tokenData.exp || "",           // optional, for TTL
            iat:tokenData.iat
            // No need to send iat or socketID anymore
        }
    });

    // Store socket globally so we can reuse it
    window.currentSocket = socket;

    socket.on("connect", () => {
        console.log("✅ Socket Connected | ID:", socket.id);
    });

    socket.on("socket-added", (response) => {
        console.log("🟢 socket-added received:", response);
        
        // Optional: You can still store socketID if you want
        if (response?.data) {
            localStorage.setItem("socketID", response.data);
        }
    });

    socket.on("disconnect", (reason) => {
        console.log("❌ Socket Disconnected:", reason);
    });

    socket.on("connect_error", (err) => {
        console.error("Socket connection error:", err.message);
    });

    return socket;
}

export default socketServices;
function Operation(obj_data, dispatch) {
    // console.log("socket-recived",obj_data)
    const { type, parcelID, data = "", success = false, message, fileName, isWithS3Buckket = false } = obj_data;
    if (type == 'ParcelDimensions' && parcelID) {
        dispatch(getDimensions({ parcelID: parcelID }))
        console.log("socket-detected-event::", { type, parcelID })
    }
    else if (['LocationSuggestion', "ReportDownload"].includes(type)) {
        showToast(message, !success)
        if (!success) {
            return;
        }
        if (isWithS3Buckket) {
            const anchor = document.createElement('a');
            anchor.href = data;
            anchor.download = `${fileName || "file"}.xlsx`;// <-- change this to your desired filename
            anchor.target = '_blank';
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
        }
        else {
            let contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            let blob = b64toBlob(data, contentType);
            let url = URL.createObjectURL(blob);
            let link = document.createElement("a");
            link.href = url;
            link.download = `${fileName || "file"}.xlsx`; // <-- change this to your desired filename
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            // Optional: revoke the object URL after download
            setTimeout(() => URL.revokeObjectURL(url), 1000);
        }
        console.log("socket-detected-event::", { type, fileName, data });

    }
    else if (type == "InventoryJourney") {
        dispatch(setStockUnitData(obj_data))
        console.log("socket-detected-event::", { type })
    }
    else if (type == "InventoryJourneyJobs") {
        dispatch(setJobQtyData(obj_data))
        console.log("socket-detected-event::", { type })
    }
    else if (type == "NotificationWeb") {
        dispatch(setWebNotificationUnreadCount(obj_data))
        showToast(data?.message, false)
        console.log("socket-detected-event::", { type })
    }
    else if (type == "AlertOnly") {
        showToast(message, !success);      
        console.log("socket-detected-event::", { type })
    }
    else if (['DownloadPDF'].includes(type)) {
        showToast(message, !success);
        if (!success) {
            return;
        }
    
        // Ensure proper .pdf extension
        const finalFileName = fileName && fileName.toLowerCase().endsWith('.pdf')
            ? fileName
            : `${fileName || 'report'}.pdf`;
    
        console.log("socket-detected-event:: PDF Download", { type, fileName: finalFileName });
    
        // Case 1: Direct URL (usually S3 signed URL)
        if (isWithS3Buckket) {
            const anchor = document.createElement('a');
            anchor.href = data;                    // signed URL
            anchor.download = finalFileName;       // forces download instead of open
            anchor.target = '_blank';              // fallback behavior
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
        }
    
        // Case 2: Base64-encoded PDF string
        else {
            const blob = b64toBlob(data, 'application/pdf');
            const url = URL.createObjectURL(blob);
    
            const link = document.createElement('a');
            link.href = url;
            link.download = finalFileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
    
            // Clean up memory to prevent leaks (especially important for large PDFs)
            setTimeout(() => URL.revokeObjectURL(url), 1000);
        }
    }
}

// Helper function to clean up socket
function cleanupSocket() {
    if (window.currentSocket) {
        window.currentSocket.removeAllListeners();   // important
        window.currentSocket.disconnect();
        window.currentSocket = null;
    }
    localStorage.removeItem("socketID");
}
export {socketServices,Operation,cleanupSocket};
